<template>
  <div>
    <el-dialog title="联系我们" v-if="isMobile" :visible.sync="contactDialog" append-to-body width="92vw" top="12vh"
      custom-class="dialogCls" :before-close="handleClose">
      <div class="contactUsDialogMain">
        <!--联系我们-->
        <div class="contactTabs">
          <h2>联系我们</h2>
          <ul>
            <li :class="isActive ? 'active' : ''" @click="changeTabs(true)"><span>参访预约</span></li>
            <li :class="!isActive ? 'active' : ''" @click="changeTabs(false)"><span>业务洽谈</span></li>
          </ul>
        </div>
        <div v-show="isActive" class="contactContainer">
          <div class="welcome">
            <div class="reservationInformation">
              <p class="infoCls">预约信息</p>
              <el-form class="elFormMain" :model="reservationForm" label-width="0">
                <el-form-item>
                  <el-input v-model="reservationForm.name1" placeholder="公司名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-input v-model="reservationForm.name2" placeholder="来访姓名"></el-input>
                    </el-col>
                    <el-col :span="12">
                      <el-input-number v-model="reservationForm.name3" placeholder="手机号" :controls="false"
                        style="width: 100%;"></el-input-number>
                    </el-col>
                  </el-row>
                  <!--                </el-form-item>

                <el-form-item>-->
                </el-form-item>
                <el-form-item>
                  <el-input v-model="reservationForm.name6" placeholder="预约内容"></el-input>
                </el-form-item>
                <p class="timeCls">预约时间</p>
                <el-form-item>
                  <el-date-picker class="comeVisitTime" style="width: 100%;" v-model="reservationForm.date1" type="date"
                    placeholder="来访日期"></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-time-picker style="width: 100%;" is-range placeholder="来访时间" v-model="reservationForm.date2"
                    range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-time-picker>
                </el-form-item>
              </el-form>
            </div>
            <div class="reservationBtn">
              <el-button type="warning" round @click="submitSubscribe">提交预约</el-button>
            </div>
          </div>
        </div>
        <div v-show="!isActive" class="businessNegotiation">
          <ul>
            <li>
              <div class="nickname">综合服务</div>
              <div class="phoneAndName">
                <span>柯经理</span>
                <i>138-5177-6595</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('13851776595')">复制</div>
            </li>
            <li>
              <div class="nickname">业务服务</div>
              <div class="phoneAndName">
                <span>王经理</span>
                <i>189-0517-1632</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('18905171632')">复制</div>
            </li>
            <li>
              <div class="nickname">全季酒店</div>
              <div class="phoneAndName">
                <span>马经理</span>
                <i>173-7295-1632</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('17372951632')">复制</div>
            </li>
            <li>
              <div class="nickname">汉庭酒店</div>
              <div class="phoneAndName">
                <span>吴经理</span>
                <i>153-6512-5609</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('15365125609')">复制</div>
            </li>
            <li>
              <div class="nickname">海友酒店</div>
              <div class="phoneAndName">
                <span>应经理</span>
                <i>177-9856-1632</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('17798561632')">复制</div>
            </li>
            <li>
              <div class="nickname">桔子酒店</div>
              <div class="phoneAndName">
                <span>应经理</span>
                <i>177-9856-1632</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('17798561632')">复制</div>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="联系我们" v-else :visible.sync="contactDialog" append-to-body width="620px" custom-class="dialogCls"
      :before-close="handleClose">
      <div class="contactUsDialogMain">
        <!--联系我们-->
        <div class="contactTabs">
          <h2>联系我们</h2>
          <ul>
            <li :class="isActive ? 'active' : ''" @click="changeTabs(true)"><span>参访预约</span></li>
            <li :class="!isActive ? 'active' : ''" @click="changeTabs(false)"><span>业务洽谈</span></li>
          </ul>
        </div>
        <div v-show="isActive" class="contactContainer">
          <div class="welcome">
            <div class="reservationInformation">
              <p class="infoCls">预约信息</p>
              <el-form class="elFormMain" :model="reservationForm" label-width="0">
                <el-form-item>
                  <el-input v-model="reservationForm.name1" placeholder="公司名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-input v-model="reservationForm.name2" placeholder="来访姓名"></el-input>
                    </el-col>
                    <el-col :span="12">
                      <el-input-number v-model="reservationForm.name3" placeholder="手机号" :controls="false"
                        style="width: 100%;"></el-input-number>
                    </el-col>
                  </el-row>
                  <!--                </el-form-item>

                <el-form-item>-->
                </el-form-item>
                <el-form-item>
                  <el-input v-model="reservationForm.name6" placeholder="预约内容"></el-input>
                </el-form-item>
                <p class="timeCls">预约时间</p>
                <el-form-item>
                  <el-date-picker class="comeVisitTime" style="width: 100%;" v-model="reservationForm.date1" type="date"
                    placeholder="来访日期"></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-time-picker style="width: 100%;" is-range placeholder="来访时间" v-model="reservationForm.date2"
                    range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-time-picker>
                </el-form-item>
              </el-form>
            </div>
            <div class="reservationBtn">
              <el-button type="warning" round @click="submitSubscribe">提交预约</el-button>
            </div>
          </div>
        </div>
        <div v-show="!isActive" class="businessNegotiation">
          <ul>
            <li>
              <div class="nickname">综合服务</div>
              <div class="phoneAndName">
                <span>柯经理</span>
                <i>138-5177-6595</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('13851776595')">复制</div>
            </li>
            <li>
              <div class="nickname">业务服务</div>
              <div class="phoneAndName">
                <span>王经理</span>
                <i>189-0517-1632</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('18905171632')">复制</div>
            </li>
            <li>
              <div class="nickname">全季酒店</div>
              <div class="phoneAndName">
                <span>马经理</span>
                <i>173-7295-1632</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('17372951632')">复制</div>
            </li>
            <li>
              <div class="nickname">汉庭酒店</div>
              <div class="phoneAndName">
                <span>吴经理</span>
                <i>153-6512-5609</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('15365125609')">复制</div>
            </li>
            <li>
              <div class="nickname">海友酒店</div>
              <div class="phoneAndName">
                <span>应经理</span>
                <i>177-9856-1632</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('17798561632')">复制</div>
            </li>
            <li>
              <div class="nickname">桔子酒店</div>
              <div class="phoneAndName">
                <span>应经理</span>
                <i>177-9856-1632</i>
              </div>
              <div class="copyBtn" @click="copyTextToClipboard('17798561632')">复制</div>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      isActive: true,
      reservationForm: {}
    };
  },
  computed: {
    ...mapState(["isMobile"]),
    ...mapGetters(['getContactDialog']), // 获取 contactDialog
    contactDialog() {
      return this.getContactDialog;
    }
  },
  methods: {
    ...mapActions(['updateContactDialog']), // 映射 action
    handleClose() {
      this.updateContactDialog(false); // 修改 contactDialog 的值为 true
    },
    changeTabs(e) {
      this.isActive = e;
    },
    copyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      // 隐藏文本域
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.width = '2em';
      textArea.style.height = '2em';
      textArea.style.padding = '0';
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';
      textArea.style.background = 'transparent';
      textArea.value = text;

      document.body.appendChild(textArea);
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? '成功' : '失败';
        this.$message.success(`复制文本${msg}-${text}`);
      } catch (err) {
        this.$message.error(`哦，无法复制${err}`);
      }
      document.body.removeChild(textArea);
    },
    submitSubscribe() {
      console.log('预约！')
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  ::v-deep .dialogCls {
    border-radius: 8px !important;

    .el-dialog__header {
      padding: 12px 16px 0 !important;

      .el-dialog__title {
        font-size: 20px !important;
      }
    }

    .el-dialog__headerbtn {
      top: 16px !important;
      right: 12px !important;

      .el-icon {
        font-size: 26px !important;
      }
    }

    .el-dialog__body {
      padding: 12px 16px 24px !important;
    }
  }


  .contactUsDialogMain {
    user-select: none;

    .contactTabs {
      margin-bottom: 30px;

      ul {
        width: 100% !important;
        height: 36px !important;

        li {
          width: 50% !important;
          height: 36px !important;
          line-height: 36px !important;
        }
      }
    }

    .contactContainer {
      width: 100% !important;

      .welcome {
        .reservationInformation {

          .elFormMain ::v-deep {
            .el-input__inner {
              border: 1px solid #999999;
              text-align: left;
              height: 42px !important;

              &::placeholder {
                text-align: left;
              }
            }

            .el-form-item {
              width: 100% !important;
              margin-bottom: 10px;
            }
          }
        }
      }
    }


    .businessNegotiation {
      ul {
        width: 100% !important;
      }

      li {
        padding: 10px 10px 10px 16px !important;
        height: 36px !important;

        .phoneAndName {
          margin-left: 12px !important;
          margin-right: 8px !important;

          span:first-child {
            padding-right: 6px !important;
            margin-right: 6px !important;
            border-right: 2px solid #aaaaaa;
          }
        }
      }

      .copyBtn {
        cursor: pointer;
        width: 46px !important;
      }
    }
  }




}

::v-deep .dialogCls {
  border-radius: 10px 10px 10px 10px;

  .el-dialog__header {
    padding: 40px 50px 0;

    .el-dialog__title {
      font-weight: bold;
      font-size: 32px;
      color: #000000;
      line-height: 38px;
    }
  }

  .el-dialog__headerbtn {
    top: 45px;
    right: 45px;

    .el-icon {
      font-size: 35px;
      color: #000000;
      font-weight: bold;
    }
  }

  .el-dialog__body {
    padding: 40px 50px;
  }
}

.contactUsDialogMain {
  user-select: none;

  .contactTabs {
    margin-bottom: 30px;

    h2 {
      font-weight: 400;
      font-size: 14px;
      color: #818188;
      line-height: 16px;
      margin-bottom: 13px;
    }

    ul {
      width: 394px;
      height: 46px;
      background: #F5F5F7;
      border-radius: 100px 100px 100px 100px;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      border: 1px solid #999999;

      li {
        width: 197px;
        height: 46px;
        line-height: 46px;
        border-radius: 100px 100px 100px 100px;
        text-align: center;
        cursor: pointer;
        // 添加过渡效果
        transition: background-color 0.3s, color 0.3s;

        &:hover {
          font-weight: bold;
        }

        &.active {
          background: #FF0053;
          color: #FFFFFF;
        }
      }
    }
  }

  .contactContainer {
    width: 520px;

    .welcome {
      .reservationInformation {
        display: flex;
        flex-direction: column;

        .infoCls {
          margin-bottom: 10px;
        }

        .timeCls {
          margin-top: 30px;
          margin-bottom: 10px;
        }

        p {
          font-size: 14px;
          color: #666666;
        }

        .elFormMain ::v-deep {
          .el-input__inner {
            border: 1px solid #999999;
            text-align: left;

            &::placeholder {
              text-align: left;
            }
          }

          .el-form-item {
            width: 520px;
            margin-bottom: 10px;

            .el-input__inner {
              height: 50px;
            }
          }

          .comeVisitTime .el-input__inner {
            padding-left: 40px;
          }

          .el-date-editor .el-range-separator {
            line-height: 42px;
          }
        }
      }

      .reservationBtn {
        margin-top: 5px;

        button {
          color: #000000;
          background: #FFDE00;
          font-size: 14px;
          font-weight: bold;
          border: 1px solid #FFDE00;

          &:hover {
            background: rgba(255, 222, 0, 0.58);
            border: 1px solid rgba(255, 222, 0, 0.58);
          }

          &:active {
            background: rgba(255, 222, 0, 0.25);
            border: 1px solid rgba(255, 222, 0, 0.25);
          }
        }
      }
    }
  }


  .businessNegotiation {
    ul {
      width: 520px;
    }

    li {
      display: flex;
      align-items: center;
      height: 50px;
      margin-bottom: 10px;
      background: #F7F8F9;
      border-radius: 10px 10px 10px 10px;
      padding: 0 30px 0 40px;
      font-size: 14px;

      .nickname {
        font-weight: bold;
        color: #000000;
      }

      .phoneAndName {
        margin-left: 70px;
        margin-right: 90px;

        span:first-child {
          padding-right: 14px;
          margin-right: 15px;
          border-right: 2px solid #aaaaaa;
        }
      }

      &:hover {
        .copyBtn {
          display: block;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .copyBtn {
      cursor: pointer;
      width: 58px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      font-size: 12px;
      color: #000000;
      font-weight: bold;
      background: #FFDE00;
      border-radius: 100px 100px 100px 100px;
      display: none;
    }
  }
}
</style>